import React from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import { Text } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useAppColors } from '../../hooks/useAppColors';
import { legalApi } from '../../api/legal';
import LegalDocumentViewer from './LegalDocumentViewer';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

export default function PublicLegalDocScreen({ route, navigation }: any) {
  const { t, i18n } = useTranslation();
  const colors = useAppColors();
  const insets = useSafeAreaInsets();
  const { docType, language } = route.params as { docType: 'privacy_policy' | 'terms_of_service'; language?: string };

  const titleLang = language || i18n.language;
  const title = docType === 'privacy_policy'
    ? t('auth.privacyPolicy', { lng: titleLang })
    : t('auth.termsOfService', { lng: titleLang });
  const url = legalApi.getPublicProxyDocUrl(docType, titleLang);

  return (
    <View style={[styles.container, { backgroundColor: colors.bg, paddingTop: insets.top }]}>
      <View style={[styles.header, { backgroundColor: colors.bgHeader, borderBottomColor: colors.border }]}>
        <TouchableOpacity onPress={() => navigation.goBack()} hitSlop={12} style={styles.backBtn}>
          <Icon name="arrow-left" size={24} color={colors.text} />
        </TouchableOpacity>
        <View style={styles.headerTitleWrap}>
          <View style={styles.headerTitleInner}>
            <Text style={[styles.headerTitle, { color: colors.text }]} numberOfLines={1}>
              {title}
            </Text>
          </View>
        </View>
        <View style={styles.headerSpacer} />
      </View>
      <View style={styles.viewer}>
        <LegalDocumentViewer url={url} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 10,
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  backBtn: { padding: 8 },
  headerTitleWrap: { flex: 1, alignItems: 'center' },
  headerTitleInner: { flexDirection: 'row', alignItems: 'center' },
  headerTitle: { fontSize: 17, fontWeight: '600' },
  headerSpacer: { width: 40 },
  viewer: { flex: 1 },
});
